import type { SearchRequest } from '@kimuno/api-sdk/lib/types/requests/Common';

import api from '../clients/api';
import { handleUnauthorized } from '../utils/apiWrapper';
import { notifyBugsnagNetwork } from '../utils/bugsnagClient';

const search = {
	unifiedSearch,
};

function unifiedSearch(searchParams: SearchRequest, abortSignal?: AbortSignal) {
	notifyBugsnagNetwork('search', 'unifiedSearch', { searchParams });
	return handleUnauthorized(() => api.search.unifiedSearch(searchParams, abortSignal));
}

export default search;
